const findCollectionByPassengerId = (passengerId, collection) => collection.find((item) => item.passenger.id === passengerId);

export default findCollectionByPassengerId;
